<!--
 * @Description: 
 * @Author: WangYuhan
 * @Date: 2022-12-09 17:54:05
 * @LastEditTime: 2023-12-12 11:03:46
 * @LastEditors: WangYuhan
-->
<template>
  <el-cascader
    class="inline-input"
    :value="value"
    filterable
    :size="size"
    :placeholder="placeholder"
    :options="options"
    :clearable="clearable"
    @clear="handclear"
    :props="{ value: 'label', label: 'label', children: 'children', checkStrictly: true }"
    @change="change"
  />
</template>

<script>
export default {
  name: 'nf-cascader1',
  props: {
    storeModelName: {
      type: String,
      required: true,
      default: '',
    },
    formData: {
      type: Object,
      required: true,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
    value: {
      type: Array,
      default: () => {},
    },
    type: {
      type: String,
      default: '',
    },
    format: {
      type: String,
      default: '',
    },
    valueFormat: {
      type: String,
      default: '',
    },
    // 输入框尺寸  默认 small  medium/small/mini
    size: {
      type: String,
      default: 'mini',
    },
    // 是否清空选项 默认false
    clearable: {
      type: Boolean,
      default: false,
    },
    // 占位符
    placeholder: {
      type: String,
      default: '',
    },
    checkStrictly: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    options() {
      // 从对应的 store module 获取 cityOptions
      // 如果 store module 中没有 cityOptions，则从 cityData module 获取
      const moduleCityOptions = this.$store.state[this.storeModelName]?.cityOptions;
      if (moduleCityOptions && moduleCityOptions.length > 0) {
        return moduleCityOptions;
      }
      // 回退到 cityData module
      return this.$store.getters['cityData/cityData'] || [];
    },
  },
  methods: {
    change(e) {
      this.$store.commit(`${this.storeModelName}/updateValueFromIndex`, {
        index: this.index,
        value: e,
      });
      if (e.length == 0) {
        this.$store.dispatch(`${this.storeModelName}/getList`);
      }
    },
    handclear() {
      this.value = [];
      this.$store.commit(`${this.storeModelName}/updateValueFromIndex`, {
        index: this.index,
        value: [],
      });
    },
  },
};
</script>
